<template>
	<div class="errorBlock">
		<div class="error-message">
				<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="24" height="24" rx="6" fill="#4DCAFF"/>
        <path d="M12 16V11" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
        <circle cx="1" cy="1" r="1" transform="matrix(1 0 0 -1 11 9)" fill="white"/>
        </svg>

			<div class="content">
				<h3>Внимание!</h3>
				<p>Вы не заполнили это поле.</p>
			</div>
		</div>
	</div>
  
</template>

<script>
export default {
  name: "ErrorMessage",
};
</script>

<style scoped>
.errorBlock {
	position: absolute;
	left:105%;
	min-width: 50%;
}
.error-message {
  position: relative;
  display: flex;
  padding: 13px;
	width: 100%;
  background-color: #FFFFFFE5;
  color: #333;
  border-radius: 8px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
}
.icon {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ff6b6b;
  width: 24px;
  height: 24px;
  margin-right: 12px;
	padding: 5px;
  color: white;
	border-radius: 6px;
}
.content {
  margin-left: 10px;
}
.content h3 {
  font-size: 14px;
  font-weight: bold;
}

.content p {
  margin: 4px 0 0;
  font-size: 14px;
  color: #666;
}

.error-message::before {
  content: "";
  position: absolute;
  left: -10px;
  top: 20px;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 10px 10px 10px 0;
  border-color: transparent #FFFFFFE5 transparent transparent;
}
@media (max-width:968px) {
  .errorBlock {
    left:50%;
    top:33%;
  }
  .error-message {
    background-color: white;
  }
}
</style>